import { render, staticRenderFns } from "./CurationListDefaultLayout.vue?vue&type=template&id=46be50ef&scoped=true&"
import script from "./CurationListDefaultLayout.vue?vue&type=script&lang=js&"
export * from "./CurationListDefaultLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46be50ef",
  null
  
)

export default component.exports